import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toString',
  standalone: true
})
export class ToStringPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value === 0) {
      return value;
    }
    return value ? parseFloat(value).toString() : '';
  }

}
